<template>
    <div id="navigation">
        <div class="navigation-wrap">
            <router-link to="/">
            <div class="logo-wrap">
                <img src="../assets/vinleit-nav-logo.jpg" alt="">
                <!-- <p>Vínval</p> -->
            </div>
            </router-link>
            <!-- SEARCH BAR
            <div class="nav-search-focus" @focusin="resultsVisibility(true)" @focusout="resultsVisibility(false)">
                <div class="nav-search-wrap">
                    <div class="nav-search">
                        <input id="nav-search-input" type="text" v-model="search_input" placeholder="Leit">
                    </div>
                </div>
                <div class="nav-search-results" v-if="search_input">
                    <div v-if="search(search_input).length == 0" class="nav-search-result-none">Ekkert fannst</div>
                    <div v-for="wine in search(search_input)" :key="wine.id" class="nav-search-result">
                        <router-link :to="{ name: 'wine-info-page', params: {wineID: wine.id} }" @click.native="search_input=''"><div class="nav-search-result-name">{{wine.name}}</div></router-link>
                    </div>
                </div>
            </div>-->
            <div class="nav-wrap">
                <router-link to="/">Heim</router-link>
                <router-link to="/vin">Öll vín</router-link>
                <router-link to="/blog">Greinar</router-link>
                <router-link to="/vin-med-mat">Vín með mat</router-link>
                <!-- <router-link to="/hafa-samband">Hafa samband</router-link> -->
                <a href="https://atelierduvin.is/">Verslun</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
    data() {
        return {
            search_input: '',

        }
    },
    methods: {
        search(input) {
            var result = []
            this.wines.forEach(wine => {
                if (wine.name.toLowerCase().includes(input.toLowerCase())) {
                    result.push(wine)
                }
            });
            // Return first 5 results only
            return result.slice(0, 5)
        },
        resultsVisibility(value) {
            if (value) {
                $('.nav-search-results').show()
            } else {
                setTimeout(function() {
                    $('.nav-search-results').hide()
                }, 100)
                
            }
        }
    },
    computed: {
        ...mapState(['wines'])
    },
}

</script>

<style>
@media only screen and (max-width: 768px) {
    .navigation-wrap {
        width:90%;
        height:100px;
    }
    .logo-wrap p {
        font-size: 30px;
    }
    .logo-wrap img {
        margin-top: 10px;
        height: 45px;
    }
    .nav-wrap {
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .nav-wrap > a {
        margin-top: 10px;
    }
    .nav-search-wrap {
        display: none;
    }
}
@media only screen and (min-width: 769px) {
    .navigation-wrap {
        width:90%;
        height:75px;
        position: relative;
    }
    .logo-wrap {
        float: left;
    }
    .logo-wrap img {
        margin-top: 5px;
        height: 65px;
    }
    .logo-wrap p {
        font-size: 40px;
        line-height: 75px;
    }
    .nav-wrap {
        float:right;
        padding:25px 0;
        /*width: 40%;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between; */
    }
    .nav-wrap > a {
        position: relative;
        text-decoration: none;
        color:#B33B3B;
        font-size: 18px;
        margin-left: 30px;
    }
    .nav-search-wrap {
        float:right;
        width: 200px;
        padding: 23px 0;
        padding-left: 20px;
    }
    .nav-search-results {
        position: absolute;
        right: 0;
        margin-top: 70px;
        width: 204px;
        text-align: left;
        background-color: white;
        box-shadow: 0 1px 4px #a8a5a3;
    }
    .nav-search-result {
        margin: 5px 10px;
        padding: 2px 5px;
        border-radius: 5px;
    }
    .nav-search-result-none {
        margin: 5px 10px;
        padding: 2px 5px;
        border-radius: 5px;
    }
    .nav-search-result-name {
        width:100%;
        height: 100%;
    }
    .nav-search-result:hover {
        background-color: #f0f0f0;
        cursor: pointer
        
    }
}
@media only screen and (min-width: 1200px) {
    .navigation-wrap {
        width:60%;
        height:75px;
    }
}
#colors {
    color: #e2dad4;
    color: #d17076;
    color: #7a2a2c;
    color: #22323f;
    color: #000c14;

    /* NEW */

    color: #7a2a2c; 
    color: #B33B3B; /* PRIMARY */
    color: #ffa987;
    color: #fec0aa;
    color: #f7ebe8;
    color: #22323f; /* TEXT */
}
#navigation {
    z-index: 100;
    position: relative;
    background-color: white;
    box-shadow: 0 1px 4px #a8a5a3;
}
.navigation-wrap {
    margin:0 auto;
}
.logo-wrap {
    cursor: pointer;
}
.logo-wrap p { 
    margin:0;
    font-weight: bold;
    letter-spacing: 2px;
    color: #B33B3B;
}
.nav-search {
    height: 30px;
    width: 100%;
    border-radius: 30px;
    background-color: white;
    border: 2px solid #f0f0f0;
}
.nav-search input {
    width: 95%;
    height: 20px;
    border: none;
    font-size: 20px;
    color: #2c3e50;
    background: transparent;
    padding: 5px 0px;
    text-align: center;
}
.nav-search input:focus {
    outline-width: 0;
}
/* .logo-wrap {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    position:absolute;
    width:100px;
    height:100px;
    border-radius: 100%;
    background-color: #f7ebe8; 
    box-shadow: 0 0 4px #000c14;
    cursor:pointer;
}
.logo-wrap img {
    display:block;
    margin:auto;
    margin-top: 19px;
    width: 40px;
} */
.nav-wrap > a:hover {
    color:#7a2a2c;
    border-bottom: solid 1px #b33b3b;
}
</style>